import { CARDS_RECEIVE } from './actions';

const defaultState = {
  cards: [],
  meta: {},
};

export default function cardsLibraryReducer(state = defaultState, action) {
  switch (action.type) {
  case CARDS_RECEIVE:
    return {
      ...state,
      cards: action.payload.cards,
      meta: action.payload.meta,
    };
  default:
    return state;
  }
}
